import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);



export const getArticleDay= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getArticleDayBerlin/select/`);
export const addArticleDay = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addArticleDayBerlin/send`, job);
export const updateArticleDay = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateArticleDayBerlin/${user.ID}`, user);
export const deleteArticleDay= user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteArticleDayBerlin/${user}`);


export const updateNewsComment = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateNews_Comment/${user.ID}`, user);

export const getSongCategory= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSong_CategoryBerlin/select/`);
export const addSongCategory = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSong_CategoryBerlin/send`, job);
export const updateSongCategory = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSong_CategoryBerlin/${user.ID}`, user);
export const deleteSongCategory= user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSong_CategoryBerlin/${user}`);



export const getNews= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getNewsBerlin/select/`);
export const addNews = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addNewsBerlin/send`, job);
export const updateNews = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateNewsBerlin/${user.ID}`, user);
export const deleteNews = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteNewsBerlin/${user}`);

const postFakeLogin = data => get(`https://adminsuvari.stechomeyazilim.info:8765/getUserLoginSuvari/select/${data.email}/${data.password}`,);


export const getNews_Category= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSliderSuvari/select/`);
export const addNews_Category = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSliderSuvari/send`, job);
export const updateNews_Category = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSliderSuvari/${user.ID}`, user);
export const deleteNews_Category= user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSliderSuvari/${user}`);


export const getNe= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getRegionsSuvari/select/`);
export const addNe = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addRegionsSuvari/send`, job);
export const updateNe = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateRegionsSuvari/${user.ID}`, user);
export const deleteNe = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteRegionsSuvari/${user}`);

export const addBolgeFetch = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postBolgeler/send`, job);

export const getNews_Comment= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getNews_CommentBerlin/select/`);
export const deleteNews_Comment = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteNews_CommentBerlin/${user}`);
export const addForum = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addForumBerlin/send`, job);




export const getPool= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getPoolBerlin/select/`);
export const addPool = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addPoolBerlin/send`, job);
export const updatePool = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updatePoolBerlin/${user.ID}`, user);
export const deletePool = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deletePoolBerlin/${user}`);

export const getAbout = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getAboutSuvari/select/`);

export const updateAbout = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateAboutSuvari/${user.ID}`, user);

export const getUsers = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getUsersSuvari/select/`);
export const addUser = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addUsersSuvari/send`, job);
export const updateUser = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateUsersSuvari/${user.ID}`, user);
export const deleteUser = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteUsersSuvari/${user}`);


export const getSong= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSongBerlin/select/`);
export const addSong = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSongBerlin/send`, job);
export const updateSong = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSongBerlin/${user.ID}`, user);
export const deleteSong = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSongBerlin/${user}`);

export const getSliders = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getOrdersSuvari/select/`);
export const updateSlider = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSlidersSuvari/${user.ID}`, user);
export const deleteSlider = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSlidersSuvari/${project}`);
  export const addSlider = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSlidersSuvari/send`, job);




  export const getAdvertesing_Category = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getPayment/select/`);
  export const updateAdvertesing_Category = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateAdvertesing_CategoryBerlin/${user.ID}`, user);
  export const deleteAdvertesing_Category = project =>
    del(`https://adminsuvari.stechomeyazilim.info:8765/deleteAdvertesing_CategoryBerlin/${project}`);
    export const addAdvertesing_Category = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addAdvertesing_CategoryBerlin/send`, job);
  
  


  export const getAdvertesing_Form = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getAnnouncementSuvari/select/`);
  export const updateAdvertesing_Form = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateAnnouncementSuvari/${user.ID}`, user);
  export const deleteAdvertesing_Form = project =>
    del(`https://adminsuvari.stechomeyazilim.info:8765/deleteAnnouncementSuvari/${project}`);
    export const addAdvertesing_Form = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addAnnouncementSuvari/send`, job);
  
        export const getJob_Advertisement = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getBolgeler/select/`);
      export const deleteJob_Advertisement = project =>
        del(`https://adminsuvari.stechomeyazilim.info:8765/deleteBolgeler/${project}`);
      export const updateJob_Advertisement = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateBolgeler/${user.ID}`, user);

    export const getJob_Advertisement_Category = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getHours/select/`);
    export const updateJob_Advertisement_Category = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateHours/${user.ID}`, user);
    export const deleteJob_Advertisement_Category = project =>
      del(`https://adminsuvari.stechomeyazilim.info:8765/deleteHours/${project}`);
      export const addJob_Advertisement_Category = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addHours/send`, job);
    
    



      export const getJob_Advertisement_SubCategory = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getJob_Advertisement_SubCategoryBerlin/select/`);
      export const updateJob_Advertisement_SubCategory = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateJob_Advertisement_SubCategoryBerlin/${user.ID}`, user);
      export const deleteJob_Advertisement_SubCategory = project =>
        del(`https://adminsuvari.stechomeyazilim.info:8765/deleteJob_Advertisement_SubCategoryBerlin/${project}`);
        export const addJob_Advertisement_SubCategory = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addJob_Advertisement_SubCategoryBerlin/send`, job);
      
      

  

     
  
      

        export const getForum = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getForumBerlin/select/`);
        export const updateForum = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateForumBerlin/${user.ID}`, user);
        export const deleteForum = project =>
          del(`https://adminsuvari.stechomeyazilim.info:8765/deleteForumBerlin/${project}`);
    
  export const getSubEducation = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSlidersBerlin/select/`);
  export const updateSubEducation = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSlidersBerlin/${user.ID}`, user);
  export const deleteSubEducation = project =>
    del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSlidersBerlin/${project}`);
    export const addSubEducation= job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSlidersBerlin/send`, job);
  

export const getCompany_Category = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getPriceSuvari/select/`);
export const updateCompany_Category = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updatePriceSuvari/${user.ID}`, user);
export const deleteCompany_Category = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deletePriceSuvari/${project}`);
  export const addCompany_Category = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addPriceSuvari/send`, job);


  export const getCompany_SubCategory = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getCompany_SubCategoryBerlin/select/`);
export const updateCompany_SubCategory = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateCompany_SubCategoryBerlin/${user.ID}`, user);
export const deleteCompany_SubCategory = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteCompany_SubCategoryBerlin/${project}`);
  export const addCompany_SubCategory = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addCompany_SubCategoryBerlin/send`, job);



  export const getMainPage_Category= () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSSSSuvari/select/`);
export const updateMainPage_Category = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSSSSuvari/${user.ID}`, user);
export const deleteMainPage_Category= project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSSSSuvari/${project}`);
  export const addMainPage_Category = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSSSSuvari/send`, job);





  export const getCompany_Advert_Price = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getCompany_Advert_PriceBerlin/select/`);
  export const updateCompany_Advert_Price= user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateCompany_Advert_PriceBerlin/${user.ID}`, user);
  export const deleteCompany_Advert_Price = project =>
    del(`https://adminsuvari.stechomeyazilim.info:8765/deleteCompany_Advert_PriceBerlin/${project}`);
    export const addCompany_Advert_Price = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addCompany_Advert_PriceBerlin/send`, job);
  

export const getCompany = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getBlogSuvari/select/`);
export const addCompany  = user => post(`https://adminsuvari.stechomeyazilim.info:8765/addBlogSuvari/send`, user);
export const updateCompany  = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateBlogSuvari/${user.ID}`, user);
export const deleteCompany  = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteBlogSuvari/${user}`);

export const getDynamicFormMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getMahalle/select/`);
export const updateDynamicForm = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateMahalle/${user.ID}`, user);
export const addDynamicForm = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postMahalle/send`, job);
export const deleteDynamicForm = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteMahalle/${project}`);

export const addEducation = user => post(`https://adminsuvari.stechomeyazilim.info:8765/addEducationNefes/send`, user);
export const addProductCategory = user => post(`https://adminsuvari.stechomeyazilim.info:8765/addProductsCategoryLuxun/send`, user);
export const deleteProductCategory = user => del(`https://adminsuvari.stechomeyazilim.info:8765/deleteProductCategoryLuxun/${user}`);
export const updateProductCategory = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateProductCategoryLuxun/${user.ID}`, user);

export const updateEducation = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateEducationNefes/${user.ID}`, user);

export const updateContact = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateContactCastor/${user.ID}`, user);
export const getCategory = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getProductsCategoryLuxun/select/`);
export const getProducts1 = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getProductsLuxun/select/`);

export const getSSS = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSSSPort/select/`);
export const getBlogs = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getBlogCastor/select/`);

export const addNewUser = user => post(`https://adminsuvari.stechomeyazilim.info:8765/postForumBerlin/send`, user);

export const getProjectsNew = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEducationNefes/select/`);
export const getEducation = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEducationNefes/select/`);
export const getEducationSubItem = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEducationSubItemNefes/select/`);
export const getPopup = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getPopupMega/select/`);
export const getWorkShop = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getTeacherMega/select/`);

export const getEventMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEventMega/select/`);




export const getMegaMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getMegaMega/select/`);

export const getMailsLists = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getContactMessageMega/select/`);

// add user


export const getEvents = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEventMega/select/`);
export const getCategories = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getEventCategoryMega/select/`);




export const updatePopup = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchPopupMega/${user.ID}`, user);

export const updateSubDomain = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchUserMega/${user.ID}`, user);


export const updateSSS = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateSSSPort/${user.ID}`, user);

export const updateProduct = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateProductLuxun/${user.ID}`, user);
export const updateBlog = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/updateBlogCastor/${user.ID}`, user);



export const updateProject = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchUpdateProject/${user.ID}`, user);


export const addPopup = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addPopup/send`, job);


export const addSSS= job => post(`https://adminsuvari.stechomeyazilim.info:8765/addSSSPort/send`, job);
export const addProduct = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addProductLuxun/send`, job);

export const addBlog = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addBlogCastor/send`, job);
export const addProject = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addProject/send`, job);



export const addMega = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addMega/send`, job);

export const addCourseMega = job => post(`https://adminsuvari.stechomeyazilim.info:8765/addCourseMega/send`, job);

export const updateSubdomain = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchSUBDOMAINMega/${user.ID}`, user);



export const updateAuth = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchAuthMega/${user.ID}`, user);

export const updateMega = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postWSMega/send`, job);

export const addWorkshop2 = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getContactCastor/select/`);
export const getAuthority = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getUsersTypeMega/select/`);
export const getWorkshop2 = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getGalleryMega/select/`);

export const addNewEvent = event => post(`https://adminsuvari.stechomeyazilim.info:8765/postEventMega/send/`, event);

export const getChats = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`https://adminsuvari.stechomeyazilim.info:8765/getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`https://adminsuvari.stechomeyazilim.info:8765/postSubdomainMega/send/`, event);
export const getReferances = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

export const addReferances = event => post(`https://adminsuvari.stechomeyazilim.info:8765/postReferancesMega/send/`, event);

export const updateReferances = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`https://adminsuvari.stechomeyazilim.info:8765/getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`https://adminsuvari.stechomeyazilim.info:8765/postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`https://adminsuvari.stechomeyazilim.info:8765/patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`https://adminsuvari.stechomeyazilim.info:8765/getClassesMega/select/`);

export const getDynamicFormExtraMega = (ID = "") => get(`https://adminsuvari.stechomeyazilim.info:8765/getDynamicFormExtraMega/select/${ID}`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`https://adminsuvari.stechomeyazilim.info:8765/getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`https://adminsuvari.stechomeyazilim.info:8765/postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteDynamicExtraExtraFormMega/${project}`);


export const deleteDynamicFormExtra = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteReferancesMega/${project}`);

export const deletePopup = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deletePopupMega/${project}`);



  export const deleteSSS = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteSSSPort/${project}`);
  





export const deleteProduct = project =>
del(`https://adminsuvari.stechomeyazilim.info:8765/deleteProductLuxun/${project}`);

  export const deleteBlog = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteblogCastor/${project}`);


  
export const deleteMega = project =>
  del(`https://adminsuvari.stechomeyazilim.info:8765/deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get maillist
//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};